export default {"src":"/_next/static/media/fantom-color.617864db.svg","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};